const Description =()=>{
    return(
        <>
        <div className="cards-1">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="above-heading">OUR VALUES</div>
                    <h2 className="h2-heading">We grow your money by attaching you to peers to contributes, supports and get increment</h2>
                </div>
            </div> 
            <div className="row">
                <div className="col-lg-12">

                    <div className="card">
                        <div className="card-image">
                            <img className="img-fluid" src="images/description-1.png" alt="alternative" />
                        </div>
                        <div className="card-body">
                            <h4 className="card-title">Save Money</h4>
                            <p>Your money is safe while it support others to grow while your money also grow</p>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-image">
                            <img className="img-fluid" src="images/description-2.png" alt="alternative" />
                        </div>
                        <div className="card-body">
                            <h4 className="card-title">Cooperative Idea</h4>
                            <p>Your donated money is shared with a peer that invest your money and come back with profit to be shared</p>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-image">
                            <img className="img-fluid" src="images/description-3.png" alt="alternative" />
                        </div>
                        <div className="card-body">
                            <h4 className="card-title">APYs</h4>
                            <p>Get full details of the xend fnance APYs in just a click with a ease of access</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
        </>
    )
}

export default Description;